// src/features/bookings/components/BookingDetail/tabs/BookingExpensesTab.jsx
import React, { useState, useEffect } from 'react';
import Button from '../../../../../shared/components/ui/Button';
import { createExpense, deleteExpense, fetchExpenseCategories } from '../../../../../api';

const fmt = (n) => parseFloat(n || 0).toLocaleString('en-US', {
  minimumFractionDigits: 0, maximumFractionDigits: 0,
});

const BookingExpensesTab = ({ booking, onDataRefresh, canAdd, canDelete, styles }) => {
  const [showForm,   setShowForm]   = useState(false);
  const [categories, setCategories] = useState([]);
  const [formData,   setFormData]   = useState({
    category: '', description: '', amount: '',
    expense_date: new Date().toISOString().slice(0, 10),
  });
  const [loadingCats, setLoadingCats] = useState(true);
  const [submitting,  setSubmitting]  = useState(false);
  const [error,       setError]       = useState('');

  useEffect(() => {
    fetchExpenseCategories('booking')
      .then(r => setCategories(r.data))
      .catch(() => {})
      .finally(() => setLoadingCats(false));
  }, []);

  const handleChange = e =>
    setFormData(p => ({ ...p, [e.target.name]: e.target.value }));

  const handleAdd = async e => {
    e.preventDefault();
    if (!formData.category || !formData.amount || !formData.description) {
      setError('يرجى ملء جميع الحقول.'); return;
    }
    setSubmitting(true); setError('');
    try {
      await createExpense({ ...formData, booking: booking.id, category: parseInt(formData.category) });
      setFormData({ category: '', description: '', amount: '', expense_date: new Date().toISOString().slice(0, 10) });
      setShowForm(false);
      onDataRefresh();
    } catch { setError('حدث خطأ أثناء حفظ المصروف.'); }
    finally { setSubmitting(false); }
  };

  const handleDelete = async id => {
    if (!window.confirm('هل أنت متأكد من حذف هذا المصروف؟')) return;
    try { await deleteExpense(id); onDataRefresh(); }
    catch { alert('فشل حذف المصروف.'); }
  };

  const expenses = booking.expenses ?? [];

  return (
    <>
      {expenses.length > 0 ? (
        <div className={styles.expensesList}>
          {expenses.map(exp => (
            <div key={exp.id} className={styles.expenseRow}>
              <span className={styles.expenseCat}>{exp.category_name}</span>
              <span className={styles.expenseDesc}>{exp.description}</span>
              <span className={styles.expenseDate}>{exp.expense_date}</span>
              <span className={styles.expenseAmount}>- {fmt(exp.amount)} د.ع</span>
              {canDelete && (
                <Button variant="danger" size="sm" onClick={() => handleDelete(exp.id)}>
                  حذف
                </Button>
              )}
            </div>
          ))}
        </div>
      ) : (
        !showForm && <p className={styles.emptyTab}>لا توجد مصاريف مسجلة.</p>
      )}

      {showForm && (
        <form onSubmit={handleAdd} className={styles.inlineForm}>
          <div className={styles.inlineFormRow}>
            <div>
              <label className={styles.formFieldLabel}>حساب المصروف *</label>
              <select name="category" value={formData.category}
                onChange={handleChange} required disabled={loadingCats}>
                <option value="">{loadingCats ? 'جاري التحميل...' : '-- اختر حساب المصروف --'}</option>
                {categories.map(c => (
                  <option key={c.id} value={c.id}>{c.name}</option>
                ))}
              </select>
            </div>
            <div>
              <label className={styles.formFieldLabel}>المبلغ *</label>
              <input type="number" step="any" name="amount" value={formData.amount}
                onChange={handleChange} placeholder="المبلغ" required />
            </div>
          </div>
          <div>
            <label className={styles.formFieldLabel}>الوصف *</label>
            <input type="text" name="description" value={formData.description}
              onChange={handleChange} placeholder="وصف المصروف" required />
          </div>
          <div>
            <label className={styles.formFieldLabel}>تاريخ الصرف *</label>
            <input type="date" name="expense_date" value={formData.expense_date}
              onChange={handleChange} required style={{ width: '200px' }} />
          </div>
          {error && <p className={styles.errorMsg}>{error}</p>}
          <div className={styles.formActions}>
            <Button variant="secondary" size="sm" type="button"
              onClick={() => setShowForm(false)}>
              إلغاء
            </Button>
            <Button variant="primary" size="sm" loading={submitting} type="submit">
              حفظ المصروف
            </Button>
          </div>
        </form>
      )}

      {canAdd && !showForm && (
        <button className={styles.addBtn} type="button" onClick={() => setShowForm(true)}>
          + إضافة مصروف جديد
        </button>
      )}
    </>
  );
};

export default BookingExpensesTab;